import React, { useReducer } from 'react';
import { useContext } from 'react';
import { createContext } from 'react';

const FavoritesContext = createContext();
const FavoritesDispatchContext = createContext();

export function useFavorites() {
    return useContext(FavoritesContext);
}

export function useFavoritesDispatch() {
    return useContext(FavoritesDispatchContext);
}

export function getFavoritesFromLS(key) {
    const saved = localStorage.getItem(key);
    if (saved == null) {
        return {};
    } else {
        return JSON.parse(saved);
    }
}

function saveFavoritesToLS(key, favorites) {
    if (Object.values(favorites).length > 0) {
        localStorage.setItem(key, JSON.stringify(favorites));
    } else {
        localStorage.removeItem(key);
    }
}

function favoritesReducer(favorites, action) {
    switch (action.type) {
        case 'toggle': {
            if (favorites[action.id] == null) {
                favorites[action.id] = true;
            } else {
                delete favorites[action.id];
            }
            saveFavoritesToLS('xs_ftns', favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export default function FavoritesProvider(props) {
    const [favorites, dispatch] = useReducer(
        favoritesReducer,
        getFavoritesFromLS('xs_ftns')
    );

    return (
        <FavoritesContext.Provider value={favorites}>
            <FavoritesDispatchContext.Provider value={dispatch}>
                {props.children}
            </FavoritesDispatchContext.Provider>
        </FavoritesContext.Provider>
    );
}
